import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { MdDoubleArrow } from "react-icons/md";
import MyVehicleCard from "./MyVehicleCard";
import { cleanCarDelete, getmycars } from "../../redux/Slice/carSlice";
import { Pagination } from "@mui/material";
import { toast } from "react-toastify";
import { getUserDetail } from "../../redux/Slice/authSlice";
import { cleanData, clearEditCarID } from "../../redux/Slice/formSlice";

const Index = () => {
  const deleteCarResponse = useSelector(
    (state) => state?.car?.deleteCarResponse
  );
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  const getMyCarsData = useSelector((state) => state?.car?.getMyCarsData);
  const loginDetail = useSelector((state) => state?.auth?.loginId);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(6); // Number of items per page

  useEffect(() => {
    if (!loginDetail) {
      navigate("/login");
    }
    dispatch(clearEditCarID())
    dispatch(cleanData())
  }, []);

  useEffect(() => {
    if (deleteCarResponse?.success === true) {
      toast.success(deleteCarResponse?.message);
      dispatch(getmycars({ userId: userDetail?.data?._id }));
      dispatch(cleanCarDelete());
    }
    if (deleteCarResponse?.success === false) {
      toast.error(deleteCarResponse?.message);
      dispatch(cleanCarDelete());
    }
  }, [deleteCarResponse]);
  useEffect(() => {
    if (userDetail?.data?._id) {
      dispatch(getmycars({ userId: userDetail?.data?._id }));
    }
    if (userDetail?.data?._id) {
      dispatch(getUserDetail(userDetail?.data?._id));
    }
  }, [dispatch, userDetail?.data?._id]);

  useEffect(() => {
    // Ensure current page is valid after data changes
    const totalPages = Math.ceil(getMyCarsData.length / itemsPerPage);
    if (currentPage > totalPages && totalPages > 0) {
      setCurrentPage(totalPages);
    } else if (totalPages === 0) {
      setCurrentPage(1);
    }
  }, [getMyCarsData, currentPage, itemsPerPage]);

  // Logic to get current items based on pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = getMyCarsData?.slice(indexOfFirstItem, indexOfLastItem);

  // Change page
  // const handlePageChange = (event, page) => {
  //   setCurrentPage(page);
  // };
  const handlePageChange = useCallback((event, page) => {
    setCurrentPage(page);
  }, []);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="container-fluid pb-6 px-0">
      <div className="container">
        {/* <div className="m-auto max_container"> */}
        <div className="d-flex flex-row fs-1 accentColor align-items-center my-2">
          <span className="lh-0">
            <MdDoubleArrow />
          </span>
          <span className="font">My Vehicle</span>
        </div>
        <div className="row pt-2">
          {currentItems && currentItems.length > 0 ? (
            currentItems.map((data) => (
              <div key={data?._id} className="col-md-6 col-lg-4 m-0 pb-4">
                <MyVehicleCard
                  carData={data}
                  carId={data?._id}
                  carImage={data?.frontImage}
                  carName={data?.maker?.carMake}
                  carSeat={data?.numberOfSeats}
                  carPrice={data?.pricePerDay}
                  rating={data?.averageRating}
                />
              </div>
            ))
          ) : (
            <div className="col-12 text-center mt-4">
              <p className="accentColor">
                No vehicles found. Add your first vehicle!
              </p>
              {/* Add a button or link to add a vehicle */}
              <Link to={"/rentyourcar"} onClick={scrollToTop}>
                <button
                  type="button"
                  className="btn img-btn primaryColor rounded-0 mt-4"
                >
                  Rent your Car
                </button>
              </Link>
            </div>
          )}
        </div>
      </div>
      <div className="mt-4 text-end">
        {getMyCarsData.length > 0 && (
          <Pagination
            count={Math.ceil(getMyCarsData.length / itemsPerPage)}
            page={currentPage}
            shape="rounded"
            onChange={handlePageChange}
          />
        )}
      </div>
    </div>
  );
};

export default Index;
